import { inject } from 'vue'
export function useLocale() {
    const LocaleStore = inject('LocaleStore')

    const lbl = LocaleStore.lbl
    const localeCode = LocaleStore.localeCode

    return {
        lbl,
        localeCode
    }
}